import React from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";

export default function NewsPage() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="container introduce-page !mt-[70px]">
      <HeaderTop title={i18next.t("help")} />
      <div className="flex flex-col gap-4 bg-black p-2">
        <Link className="bg-[#1c1c1e] rounded" to="/news/detail/1">
          <img
            src="https://api.demo92.apptestlive.com/assets/images/howaretheydifferent.png"
            alt="banner"
            height="100"
            width="100"
            className="w-full"
          />
          <div className="flex flex-col gap-2 p-4">
            <h2 className="text-xl text-white">
              USDT vs. USDC vs. BUSD: How Are They Different?
            </h2>
            <span className="text-sm text-[#888] whitespace-nowrap text-ellipsis overflow-hidden">
              Stablecoins are cryptocurrencies whose values are pegged to a
              stable asset, mostly fiat currencies. Tether (USDT), USD Coin
              (USDC) and Binance USD (BUSD) are the three most popular
              stablecoins, with a combined market cap of $120 billion. However,
              with the recent buzz around BUSD, there’s no doubt that most
              investors would be curious to know if BUSD is still worth
              investing in — or if you should simply pile your investments into
              USDT, USDC or other stablecoins instead.
            </span>
          </div>
        </Link>
        <Link className="bg-[#1c1c1e] rounded" to="/news/detail/2">
          <img
            src="https://api.demo92.apptestlive.com/assets/images/whichoneisrightforyou.png"
            alt="banner"
            height="100"
            width="100"
            className="w-full"
          />
          <div className="flex flex-col gap-2 p-4">
            <h2 className="text-xl text-white">
              Traditional Debit Card vs. Crypto Debit Card: Which One Is Right
              For You?
            </h2>
            <span className="text-sm text-[#888] whitespace-nowrap text-ellipsis overflow-hidden">
              Modern society increasingly focuses on cashless transactions.
              Being able to pay by scanning a card can make a lot of
              transactions faster, easier and more secure. However, it brings up
              some new questions for consumers. How do you pick which card you
              want to pay with? There are a lot of options, and they all have
              their pros and cons. Traditional debit cards and crypto debit
              cards are two of the most popular choices. To find the right
              option, you'll need to carefully consider your personal budget and
              preferences.
            </span>
          </div>
        </Link>
        <Link className="bg-[#1c1c1e] rounded" to="/news/detail/3">
          <img
            src="https://api.demo92.apptestlive.com/assets/images/coticrypto.png"
            alt="banner"
            height="100"
            width="100"
            className="w-full"
          />
          <div className="flex flex-col gap-2 p-4">
            <h2 className="text-xl text-white">
              Coti Crypto: Instant Payment Around The World
            </h2>
            <span className="text-sm text-[#888] whitespace-nowrap text-ellipsis overflow-hidden">
              As we know, traditional finance is plagued with many pressing
              issues such as merchant fees and cross-border barriers. Digital
              currency transactions powered by blockchain technology offer a
              potential solution. However, it is not perfect either because of
              its low transaction speeds, delays in payment confirmations and
              many scalability issues.
            </span>
          </div>
        </Link>
        <Link className="bg-[#1c1c1e] rounded" to="/news/detail/4">
          <img
            src="https://api.demo92.apptestlive.com/assets/images/whatisPoWinblockchain.png"
            alt="banner"
            height="100"
            width="100"
            className="w-full"
          />
          <div className="flex flex-col gap-2 p-4">
            <h2 className="text-xl text-white">
              Explained: What Is Proof of Work (PoW) in Blockchain?
            </h2>
            <span className="text-sm text-[#888] whitespace-nowrap text-ellipsis overflow-hidden">
              The blockchain is commonly perceived through the prism of
              Bitcoin’s Nakamoto Consensus. But in order to learn more about
              what Proof of Work is, it is essential to look closely into the
              sustainable PoW implementation.
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
}
